var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", { staticClass: "page-title-bar" }, [
        _c("img", {
          staticStyle: { "margin-right": "10px", width: "28px" },
          attrs: { src: require("@/assets/img/camera.png") }
        }),
        _vm._v(
          " " +
            _vm._s(_vm.$t("Device")) +
            " (" +
            _vm._s(_vm.$t("Camera")) +
            ") "
        )
      ]),
      _c(
        "v-row",
        { staticClass: "dashboard-row mt-5", attrs: { dense: "" } },
        [
          _c("v-col", { attrs: { cols: "6" } }, [
            _c(
              "div",
              { staticClass: "dashboard-scroll" },
              [
                _c(
                  "v-card",
                  { staticClass: "dashboard-box donut-card pa-6 flex-grow-1" },
                  [
                    _c("div", { staticClass: "card-title" }, [
                      _vm._v(_vm._s(_vm.$t("Device Status")))
                    ]),
                    _c("div", { staticClass: "device-wrapper" }, [
                      _c(
                        "div",
                        { staticClass: "donut-section" },
                        [
                          _vm.hasDonutData
                            ? [
                                _c("apexchart", {
                                  attrs: {
                                    type: "donut",
                                    width: "100%",
                                    height: "220",
                                    options: _vm.donutOptions,
                                    series: _vm.donutSeries
                                  }
                                })
                              ]
                            : _c("div", { staticClass: "empty-chart-state" }, [
                                _c("i", {
                                  staticClass: "mdi mdi-chart-bar empty-icon"
                                }),
                                _c("p", { staticClass: "empty-text" }, [
                                  _vm._v(_vm._s(_vm.$t("No data available")))
                                ])
                              ])
                        ],
                        2
                      ),
                      _c("div", { staticClass: "stats-section" }, [
                        _c("div", { staticClass: "stats-row px-3" }, [
                          _c("div", { staticClass: "stat-block" }, [
                            _c(
                              "div",
                              { staticClass: "stat-label yellow-dot" },
                              [_vm._v(_vm._s(_vm.$t("Battery Bad")))]
                            ),
                            _c("div", { staticClass: "stat-value" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.donutSeries[0] ? _vm.donutSeries[0] : "-"
                                )
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "stat-block" }, [
                            _c("div", { staticClass: "stat-label red-dot" }, [
                              _vm._v(_vm._s(_vm.$t("Disconnected")))
                            ]),
                            _c("div", { staticClass: "stat-value" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.donutSeries[1] ? _vm.donutSeries[1] : "-"
                                )
                              )
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]
                )
              ],
              1
            )
          ]),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("v-card", { staticClass: "dashboard-box pa-6" }, [
                _c("div", { staticClass: "card-title mb-2" }, [
                  _vm._v(_vm._s(_vm.$t("Capture Command")))
                ]),
                _c(
                  "div",
                  { staticClass: "chart-container" },
                  [
                    _vm.hasChartData
                      ? [
                          _c("apexchart", {
                            attrs: {
                              type: "bar",
                              width: "100%",
                              height: "100%",
                              options: _vm.chartOptions,
                              series: _vm.chartSeries
                            }
                          })
                        ]
                      : _c("div", { staticClass: "empty-chart-state" }, [
                          _c("i", {
                            staticClass: "mdi mdi-chart-bar empty-icon"
                          }),
                          _c("p", { staticClass: "empty-text" }, [
                            _vm._v(_vm._s(_vm.$t("No data available")))
                          ])
                        ])
                  ],
                  2
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "v-row",
            { staticClass: "pa-0 ma-0" },
            [
              _c(
                "v-col",
                {
                  staticClass: "d-flex align-center justify-center pb-0",
                  attrs: { cols: "2" }
                },
                [
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "offset-y": "",
                        "close-on-content-click": false,
                        "content-class": "columnMenu"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "manage-btn btn",
                                      attrs: { text: "", small: "" }
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("Manage Columns")) + " "
                                  ),
                                  _c(
                                    "v-icon",
                                    {
                                      class: { rotate: _vm.menuOpen },
                                      attrs: { right: "" }
                                    },
                                    [_vm._v(" mdi-chevron-down ")]
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.menuOpen,
                        callback: function($$v) {
                          _vm.menuOpen = $$v
                        },
                        expression: "menuOpen"
                      }
                    },
                    [
                      _c(
                        "v-card",
                        { staticClass: "column-card" },
                        [
                          _c("v-card-title", { staticClass: "column-header" }, [
                            _vm._v(" " + _vm._s(_vm.$t("Select Columns")) + " ")
                          ]),
                          _c("v-divider"),
                          _c(
                            "v-list",
                            { staticClass: "select-all", attrs: { dense: "" } },
                            [
                              _c(
                                "v-list-item",
                                [
                                  _c("v-checkbox", {
                                    attrs: {
                                      "input-value": _vm.isAllSelected,
                                      "hide-details": ""
                                    },
                                    on: { change: _vm.toggleSelectAll }
                                  }),
                                  _c("v-list-item-title", [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("Select All")) + " "
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c("v-divider"),
                          _c(
                            "v-card-text",
                            { staticClass: "column-list" },
                            [
                              _c(
                                "v-list",
                                { attrs: { dense: "" } },
                                _vm._l(_vm.headers.slice(1), function(header) {
                                  return _c(
                                    "v-list-item",
                                    { key: header.value },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          value: header.text,
                                          "hide-details": ""
                                        },
                                        model: {
                                          value: _vm.visibleColumns,
                                          callback: function($$v) {
                                            _vm.visibleColumns = $$v
                                          },
                                          expression: "visibleColumns"
                                        }
                                      }),
                                      _c(
                                        "v-list-item-title",
                                        { staticClass: "column-text" },
                                        [
                                          _vm._v(
                                            " " + _vm._s(header.text) + " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c("v-divider"),
                          _c(
                            "v-card-actions",
                            { staticClass: "column-footer" },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticStyle: {
                                    background: "#c57171",
                                    color: "#ffffff !important",
                                    width: "80px"
                                  },
                                  attrs: {
                                    color: "error",
                                    text: "",
                                    small: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.menuOpen = false
                                    }
                                  }
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("Cancel")) + " ")]
                              ),
                              _c("v-spacer"),
                              _c(
                                "v-btn",
                                {
                                  staticStyle: { width: "80px" },
                                  attrs: { color: "primary", small: "" },
                                  on: {
                                    click: function($event) {
                                      _vm.menuOpen = false
                                      _vm.saveVisibleColumns()
                                    }
                                  }
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("Save")) + " ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "d-flex align-center justify-center pa-0 mt-6",
                  attrs: { cols: "1" }
                },
                [_c("v-divider", { attrs: { vertical: "" } })],
                1
              ),
              _c(
                "v-col",
                { staticClass: "d-flex flex-column", attrs: { cols: "9" } },
                [
                  _c(
                    "section",
                    { staticClass: "searchArea d-flex" },
                    [
                      _c("v-text-field", {
                        staticClass: "form-input",
                        staticStyle: { width: "20%" },
                        attrs: {
                          label: _vm.$t("Camera ID"),
                          placeholder: _vm.$t("Camera ID"),
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                          clearable: ""
                        },
                        model: {
                          value: _vm.searchBy.cameraID,
                          callback: function($$v) {
                            _vm.$set(_vm.searchBy, "cameraID", $$v)
                          },
                          expression: "searchBy.cameraID"
                        }
                      }),
                      _c("v-select", {
                        staticClass: "form-select ml-3",
                        staticStyle: { width: "20%" },
                        attrs: {
                          items: _vm.floors,
                          label: _vm.$t("Floor"),
                          placeholder: _vm.$t("Select Floor"),
                          clearable: "",
                          outlined: "",
                          dense: "",
                          "persistent-hint": "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.searchBy.floor,
                          callback: function($$v) {
                            _vm.$set(_vm.searchBy, "floor", $$v)
                          },
                          expression: "searchBy.floor"
                        }
                      }),
                      _c("v-select", {
                        staticClass: "form-select ml-3",
                        staticStyle: { width: "20%" },
                        attrs: {
                          items: _vm.statusList,
                          label: _vm.$t("Status"),
                          placeholder: _vm.$t("Select Status"),
                          "item-text": "text",
                          "item-value": "value",
                          clearable: "",
                          outlined: "",
                          dense: "",
                          "persistent-hint": "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.searchBy.status,
                          callback: function($$v) {
                            _vm.$set(_vm.searchBy, "status", $$v)
                          },
                          expression: "searchBy.status"
                        }
                      }),
                      _c("v-select", {
                        staticClass: "form-select ml-3",
                        staticStyle: { width: "20%" },
                        attrs: {
                          items: _vm.connectionList,
                          label: _vm.$t("Connection"),
                          placeholder: _vm.$t("Select Connection"),
                          "item-text": "text",
                          "item-value": "value",
                          clearable: "",
                          outlined: "",
                          dense: "",
                          "persistent-hint": "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.searchBy.connection,
                          callback: function($$v) {
                            _vm.$set(_vm.searchBy, "connection", $$v)
                          },
                          expression: "searchBy.connection"
                        }
                      }),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn type-search ml-10",
                          staticStyle: { width: "120px" },
                          attrs: { text: "" },
                          on: {
                            click: function($event) {
                              return _vm.search()
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("Search")) + " ")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "section",
                    { staticClass: "searchArea d-flex" },
                    [
                      _c("v-select", {
                        staticClass: "form-input",
                        staticStyle: { width: "20%" },
                        attrs: {
                          items: _vm.batteryList,
                          label: _vm.$t("Battery"),
                          placeholder: _vm.$t("Select Battery value"),
                          "item-text": "text",
                          "item-value": "value",
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                          clearable: ""
                        },
                        model: {
                          value: _vm.searchBy.battery,
                          callback: function($$v) {
                            _vm.$set(_vm.searchBy, "battery", $$v)
                          },
                          expression: "searchBy.battery"
                        }
                      }),
                      _c("v-select", {
                        staticClass: "form-select ml-3",
                        staticStyle: { width: "20%" },
                        attrs: {
                          items: _vm.signalList,
                          label: _vm.$t("Signal Strength"),
                          placeholder: _vm.$t("Select Signal Strength"),
                          "item-text": "text",
                          "item-value": "value",
                          clearable: "",
                          outlined: "",
                          dense: "",
                          "persistent-hint": "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.searchBy.signal,
                          callback: function($$v) {
                            _vm.$set(_vm.searchBy, "signal", $$v)
                          },
                          expression: "searchBy.signal"
                        }
                      }),
                      _c("v-text-field", {
                        staticClass: "ml-3 form-input",
                        staticStyle: { width: "20%" },
                        attrs: {
                          label: _vm.$t("Shelf Group ID"),
                          placeholder: _vm.$t("Input Shelf Group ID"),
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                          clearable: ""
                        },
                        model: {
                          value: _vm.searchBy.shelfGroup,
                          callback: function($$v) {
                            _vm.$set(_vm.searchBy, "shelfGroup", $$v)
                          },
                          expression: "searchBy.shelfGroup"
                        }
                      }),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn type-search ml-10",
                          staticStyle: { width: "120px" },
                          attrs: { text: "" },
                          on: {
                            click: function($event) {
                              return _vm.clear()
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("Clear")) + " ")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c("v-data-table", {
            staticClass: "tbl-type01 mt-10 products",
            attrs: {
              "item-key": "labelCode",
              headers: _vm.filteredHeaders,
              items: _vm.tableData,
              "hide-default-footer": true,
              "items-per-page": 10,
              "fixed-header": "",
              "single-select": "",
              "show-select": "",
              options: _vm.options
            },
            on: {
              "update:options": function($event) {
                _vm.options = $event
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "item.updateStatus",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      item.updateStatus === "TIMEOUT"
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: {
                                top: "",
                                "content-class": "v-tooltip-resize2"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          "span",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                class: _vm.statusStyle(
                                                  item.updateStatus
                                                )
                                              },
                                              "span",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c("b", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(item.updateStatus)
                                                ) + "* "
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _c("div", { staticClass: "tooltip-content" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(item.statusMessage || "No response")
                                  )
                                ])
                              ])
                            ]
                          )
                        : _c(
                            "span",
                            { class: _vm.statusStyle(item.updateStatus) },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t(item.updateStatus)) + " "
                              )
                            ]
                          )
                    ]
                  }
                },
                {
                  key: "item.battery",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c(
                        "span",
                        {
                          class:
                            item.battery === "GOOD"
                              ? "txt-stable"
                              : "txt-danger"
                        },
                        [_vm._v(_vm._s(item.battery))]
                      )
                    ]
                  }
                },
                {
                  key: "item.networkStatus",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c(
                        "v-tooltip",
                        {
                          attrs: {
                            top: "",
                            "content-class": "tooltip-content"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "div",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "status-dot ml-8",
                                            class:
                                              item.networkStatus === false
                                                ? "offline"
                                                : "online"
                                          },
                                          "div",
                                          attrs,
                                          false
                                        ),
                                        on
                                      )
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.networkStatus === false
                                    ? "Offline"
                                    : "Online"
                                ) +
                                " "
                            )
                          ])
                        ]
                      )
                    ]
                  }
                },
                {
                  key: "item.lastCaptureTime",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      item.captureStatus !== 1 &&
                      item.captureStatus !== null &&
                      item.captureStatus !== undefined
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          "span",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass:
                                                  "d-flex flex-column align-center",
                                                staticStyle: {
                                                  width: "fit-content"
                                                }
                                              },
                                              "span",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(
                                              "v-chip",
                                              {
                                                staticClass: "status-chip",
                                                attrs: {
                                                  outlined: "",
                                                  "x-small": "",
                                                  color: "#EA3F65"
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "mr-1",
                                                    attrs: { size: "10" }
                                                  },
                                                  [_vm._v("mdi-close")]
                                                ),
                                                _vm._v(
                                                  " " + _vm._s(_vm.$t("FAILED"))
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.lastCaptureTime || "-"
                                                ) +
                                                " "
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.CAPTURE_STATUS_MAP[item.captureStatus]
                                        ? _vm.CAPTURE_STATUS_MAP[
                                            item.captureStatus
                                          ].name
                                        : ""
                                    ) +
                                    " "
                                )
                              ])
                            ]
                          )
                        : item.captureStatus === null ||
                          item.captureStatus === undefined
                        ? _c("span", [
                            _vm._v(
                              " " + _vm._s(item.lastCaptureTime || "-") + " "
                            )
                          ])
                        : _c(
                            "span",
                            {
                              staticClass: "d-flex flex-column align-center",
                              staticStyle: { width: "fit-content" }
                            },
                            [
                              _c(
                                "v-chip",
                                {
                                  staticClass: "status-chip",
                                  attrs: {
                                    outlined: "",
                                    "x-small": "",
                                    color: "#2ABC4E"
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-1",
                                      attrs: { size: "10" }
                                    },
                                    [_vm._v("mdi-check-bold")]
                                  ),
                                  _vm._v(" " + _vm._s(_vm.$t("SUCCESS")))
                                ],
                                1
                              ),
                              _vm._v(
                                " " + _vm._s(item.lastCaptureTime || "-") + " "
                              )
                            ],
                            1
                          )
                    ]
                  }
                },
                {
                  key: "item.details",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c(
                        "v-icon",
                        {
                          attrs: {
                            small: "",
                            disabled: _vm.btnDisabledDetails
                          },
                          on: {
                            click: function($event) {
                              return _vm.openDetails(item)
                            }
                          }
                        },
                        [_vm._v("mdi-file-eye")]
                      )
                    ]
                  }
                },
                {
                  key: "item.history",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c(
                        "v-icon",
                        {
                          attrs: { small: "" },
                          on: {
                            click: function($event) {
                              return _vm.openHistory(item)
                            }
                          }
                        },
                        [_vm._v("mdi-history")]
                      )
                    ]
                  }
                }
              ],
              null,
              true
            ),
            model: {
              value: _vm.selected,
              callback: function($$v) {
                _vm.selected = $$v
              },
              expression: "selected"
            }
          }),
          _c(
            "v-row",
            { staticClass: "mt-4" },
            [
              _c(
                "v-col",
                {
                  staticClass: "d-flex justify-space-between align-end",
                  attrs: { cols: "12" }
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn mr-2",
                          attrs: {
                            text: "",
                            disabled:
                              _vm.selected.length === 0 ||
                              _vm.btnDisabledDetails
                          },
                          on: {
                            click: function($event) {
                              return _vm.captureNow()
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("mdi-camera")
                          ]),
                          _vm._v(" " + _vm._s(_vm.$t("Capture Now")) + " ")
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn mr-2",
                          attrs: {
                            text: "",
                            disabled:
                              _vm.btnDisabledExport ||
                              _vm.tableData.length === 0
                          },
                          on: {
                            click: function($event) {
                              return _vm.exportRecords()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Export")))]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn unassign mr-2",
                          attrs: {
                            text: "",
                            disabled:
                              _vm.selected.length !== 1 ||
                              _vm.btnDisabledDetails
                          },
                          on: { click: _vm.unlinkDevice }
                        },
                        [_vm._v(_vm._s(_vm.$t("Unassign")))]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn delete mr-2",
                          attrs: {
                            text: "",
                            disabled:
                              _vm.selected.length !== 1 ||
                              _vm.btnDisabledDetails
                          },
                          on: { click: _vm.deleteDevice }
                        },
                        [_vm._v(_vm._s(_vm.$t("Delete")))]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn schedule mr-2",
                          attrs: { text: "", disabled: _vm.btnDisabledDetails },
                          on: {
                            click: function($event) {
                              return _vm.captureScheSetting()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Schedule Settings")))]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn mr-2 repeat",
                          attrs: { text: "", disabled: _vm.btnDisabledDetails },
                          on: {
                            click: function($event) {
                              return _vm.deleteRepeatSchedule()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Delete Repeat Schedule")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c("Pagination", {
                        attrs: {
                          pageInfoText: _vm.pageInfoText,
                          pageIndex: _vm.pageIndex,
                          rowPerPage: _vm.rowPerPage,
                          goToPageInput: _vm.goToPageInput,
                          totalPages: _vm.totalPages
                        },
                        on: {
                          paging: function($event) {
                            return _vm.paging($event)
                          },
                          updatePage: function($event) {
                            return _vm.updatePage($event)
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c("a", { ref: "link", style: { display: "none" } }),
          _vm.captureScheduleDetailsDailog
            ? _c("Capture-Schedule-Setting", {
                attrs: {
                  captureScheduleDetailsDailog: _vm.captureScheduleDetailsDailog
                },
                on: {
                  closeModalCapture: function($event) {
                    _vm.captureScheduleDetailsDailog = false
                  }
                }
              })
            : _vm._e(),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "1100", scrollable: "", persistent: "" },
              model: {
                value: _vm.detailsDialog,
                callback: function($$v) {
                  _vm.detailsDialog = $$v
                },
                expression: "detailsDialog"
              }
            },
            [
              _c(
                "v-card",
                { staticClass: "popup" },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "d-flex justify-space-between" },
                    [
                      _c("h3", { staticClass: "page-title-bar mb-0" }, [
                        _c("img", {
                          staticStyle: {
                            "margin-right": "10px",
                            width: "30px"
                          },
                          attrs: { src: require("@/assets/img/camera.png") }
                        }),
                        _vm._v(_vm._s(_vm.$t("Camera Details")) + " ")
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "px-6 pt-4" },
                    [
                      _c(
                        "v-tabs",
                        {
                          staticClass: "custom-tabs",
                          attrs: {
                            "background-color": "#001E38",
                            color: "#fff",
                            grow: ""
                          },
                          on: { change: _vm.handleTabChange },
                          model: {
                            value: _vm.activeTab,
                            callback: function($$v) {
                              _vm.activeTab = $$v
                            },
                            expression: "activeTab"
                          }
                        },
                        [
                          _c("v-tab", [
                            _vm._v(" " + _vm._s(_vm.$t("Settings")) + " ")
                          ]),
                          _c("v-tab", [
                            _vm._v(
                              " " + _vm._s(_vm.$t("Capture History")) + " "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    { staticClass: "details-body pb-0" },
                    [
                      _c(
                        "v-tabs-items",
                        {
                          model: {
                            value: _vm.activeTab,
                            callback: function($$v) {
                              _vm.activeTab = $$v
                            },
                            expression: "activeTab"
                          }
                        },
                        [
                          _c("v-tab-item", [
                            _c(
                              "div",
                              { staticClass: "settings-tab-content pb-0" },
                              [
                                _c("div", { staticClass: "settings-section" }, [
                                  _c("div", { staticClass: "section-header" }, [
                                    _c("span", {
                                      staticClass: "section-accent"
                                    }),
                                    _c(
                                      "span",
                                      { staticClass: "section-title" },
                                      [_vm._v(_vm._s(_vm.$t("Camera Info")))]
                                    )
                                  ]),
                                  _c("div", { staticClass: "info-grid" }, [
                                    _c(
                                      "div",
                                      { staticClass: "info-item" },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "form-input",
                                          attrs: {
                                            label: _vm.$t("Camera ID"),
                                            placeholder: _vm.$t("Camera ID"),
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "",
                                            disabled: ""
                                          },
                                          model: {
                                            value: _vm.detailslabelCode,
                                            callback: function($$v) {
                                              _vm.detailslabelCode = $$v
                                            },
                                            expression: "detailslabelCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "info-item" },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "form-input",
                                          attrs: {
                                            label: _vm.$t("Location"),
                                            placeholder: _vm.$t("Location"),
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "",
                                            disabled: ""
                                          },
                                          model: {
                                            value: _vm.detailsLocation,
                                            callback: function($$v) {
                                              _vm.detailsLocation = $$v
                                            },
                                            expression: "detailsLocation"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "info-item" },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "form-input",
                                          attrs: {
                                            label: _vm.$t("Config"),
                                            placeholder: _vm.$t("Config"),
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "",
                                            disabled: ""
                                          },
                                          model: {
                                            value: _vm.detailsConfig,
                                            callback: function($$v) {
                                              _vm.detailsConfig = $$v
                                            },
                                            expression: "detailsConfig"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "info-item" },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "form-input",
                                          attrs: {
                                            label: _vm.$t("Schedule"),
                                            placeholder: _vm.$t("Schedule"),
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "",
                                            disabled: ""
                                          },
                                          model: {
                                            value: _vm.detailsSchedule,
                                            callback: function($$v) {
                                              _vm.detailsSchedule = $$v
                                            },
                                            expression: "detailsSchedule"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "info-item" },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "form-input",
                                          attrs: {
                                            label: _vm.$t("Repeat Schedule"),
                                            placeholder: _vm.$t(
                                              "Repeat Schedule"
                                            ),
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "",
                                            disabled: ""
                                          },
                                          model: {
                                            value: _vm.detailsRepeatSchedule,
                                            callback: function($$v) {
                                              _vm.detailsRepeatSchedule = $$v
                                            },
                                            expression: "detailsRepeatSchedule"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ])
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "settings-section" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "section-header" },
                                      [
                                        _c("span", {
                                          staticClass: "section-accent"
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "section-title" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("WiFi Settings"))
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "v-row",
                                      { attrs: { dense: "" } },
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "6" } },
                                          [
                                            _c("v-text-field", {
                                              staticClass: "form-input",
                                              attrs: {
                                                label: _vm.$t("SSID"),
                                                placeholder: _vm.$t("SSID"),
                                                outlined: "",
                                                dense: "",
                                                "hide-details": "",
                                                clearable: ""
                                              },
                                              model: {
                                                value: _vm.detailsSsid,
                                                callback: function($$v) {
                                                  _vm.detailsSsid = $$v
                                                },
                                                expression: "detailsSsid"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "6" } },
                                          [
                                            _c("v-text-field", {
                                              staticClass: "form-input",
                                              attrs: {
                                                value: _vm.showPwd
                                                  ? _vm.detailsPassword
                                                  : "••••••••",
                                                "append-icon": _vm.showPwd
                                                  ? "mdi-eye"
                                                  : "mdi-eye-off",
                                                label: _vm.$t("Password"),
                                                outlined: "",
                                                dense: "",
                                                "hide-details": ""
                                              },
                                              on: {
                                                input: function($event) {
                                                  _vm.detailsPassword = $event
                                                },
                                                "click:append": function(
                                                  $event
                                                ) {
                                                  _vm.showPwd = !_vm.showPwd
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "settings-section" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "section-header" },
                                      [
                                        _c("span", {
                                          staticClass: "section-accent"
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "section-title" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("Upload Settings"))
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "v-row",
                                      { attrs: { dense: "" } },
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "4" } },
                                          [
                                            _c("v-text-field", {
                                              staticClass: "form-input",
                                              attrs: {
                                                label: _vm.$t("Host URL"),
                                                placeholder: _vm.$t("Host URL"),
                                                outlined: "",
                                                dense: "",
                                                "hide-details": "",
                                                clearable: ""
                                              },
                                              model: {
                                                value: _vm.detailsHost,
                                                callback: function($$v) {
                                                  _vm.detailsHost = $$v
                                                },
                                                expression: "detailsHost"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "4" } },
                                          [
                                            _c("v-text-field", {
                                              staticClass: "form-input",
                                              attrs: {
                                                label: _vm.$t("Key"),
                                                placeholder: _vm.$t("Key"),
                                                outlined: "",
                                                dense: "",
                                                "hide-details": "",
                                                clearable: ""
                                              },
                                              model: {
                                                value: _vm.detailsKey,
                                                callback: function($$v) {
                                                  _vm.detailsKey = $$v
                                                },
                                                expression: "detailsKey"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "4" } },
                                          [
                                            _c("v-text-field", {
                                              staticClass: "form-input",
                                              attrs: {
                                                value: _vm.showSecret
                                                  ? _vm.detailsSecret
                                                  : "••••••••",
                                                "append-icon": _vm.showSecret
                                                  ? "mdi-eye"
                                                  : "mdi-eye-off",
                                                label: _vm.$t("Secret"),
                                                outlined: "",
                                                dense: "",
                                                "hide-details": ""
                                              },
                                              on: {
                                                input: function($event) {
                                                  _vm.detailsSecret = $event
                                                },
                                                "click:append": function(
                                                  $event
                                                ) {
                                                  _vm.showSecret = !_vm.showSecret
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "show-more-toggle" },
                                  [
                                    _c("v-divider", {
                                      staticClass: "flex-grow-1"
                                    }),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "toggle-btn mx-3",
                                        attrs: { text: "", "x-small": "" },
                                        on: {
                                          click: function($event) {
                                            _vm.showMore = !_vm.showMore
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "mr-1",
                                            attrs: { small: "" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.showMore
                                                  ? "mdi-chevron-up"
                                                  : "mdi-chevron-down"
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.showMore
                                                ? _vm.$t("Show Less Setting")
                                                : _vm.$t("Show More Setting")
                                            ) +
                                            " "
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c("v-expand-transition", [
                                  _vm.showMore
                                    ? _c(
                                        "div",
                                        { staticClass: "settings-section" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "section-header" },
                                            [
                                              _c("span", {
                                                staticClass: "section-accent"
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "section-title"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("Camera Settings")
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "v-row",
                                            { attrs: { dense: "" } },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("v-text-field", {
                                                    staticClass: "form-input",
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "Brightness"
                                                      ),
                                                      placeholder: _vm.$t(
                                                        "Input Brightness(0 ~ 128)"
                                                      ),
                                                      outlined: "",
                                                      dense: "",
                                                      "hide-details": "",
                                                      clearable: ""
                                                    },
                                                    model: {
                                                      value: _vm.brightness,
                                                      callback: function($$v) {
                                                        _vm.brightness = $$v
                                                      },
                                                      expression: "brightness"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("v-text-field", {
                                                    staticClass: "form-input",
                                                    attrs: {
                                                      label: _vm.$t("Contrast"),
                                                      placeholder: _vm.$t(
                                                        "Input Contrast(0 ~ 100)"
                                                      ),
                                                      outlined: "",
                                                      dense: "",
                                                      "hide-details": "",
                                                      clearable: ""
                                                    },
                                                    model: {
                                                      value: _vm.contrast,
                                                      callback: function($$v) {
                                                        _vm.contrast = $$v
                                                      },
                                                      expression: "contrast"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("v-select", {
                                                    staticClass: "form-select",
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "Retry Count"
                                                      ),
                                                      placeholder: _vm.$t(
                                                        "Enter The Retry Count"
                                                      ),
                                                      items:
                                                        _vm.retryCountItems,
                                                      outlined: "",
                                                      dense: "",
                                                      "hide-details": "",
                                                      clearable: ""
                                                    },
                                                    model: {
                                                      value: _vm.retryCount,
                                                      callback: function($$v) {
                                                        _vm.retryCount = $$v
                                                      },
                                                      expression: "retryCount"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("v-select", {
                                                    staticClass: "form-select",
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "Retry Interval Count"
                                                      ),
                                                      placeholder: _vm.$t(
                                                        "Enter The Retry Interval Count"
                                                      ),
                                                      items:
                                                        _vm.intervalCountItems,
                                                      outlined: "",
                                                      dense: "",
                                                      "hide-details": "",
                                                      clearable: ""
                                                    },
                                                    model: {
                                                      value: _vm.retryInterval,
                                                      callback: function($$v) {
                                                        _vm.retryInterval = $$v
                                                      },
                                                      expression:
                                                        "retryInterval"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ])
                              ],
                              1
                            )
                          ]),
                          _c("v-tab-item", [
                            _c("div", { staticClass: "capture-history" }, [
                              _c(
                                "div",
                                { staticClass: "capture-table-section" },
                                [
                                  _c("v-data-table", {
                                    staticClass: "tbl-type01 products images",
                                    attrs: {
                                      headers: _vm.scheduleHeaders,
                                      items: _vm.scheduleList,
                                      "hide-default-footer": true,
                                      "items-per-page": -1,
                                      "fixed-header": "",
                                      height: "100%",
                                      "item-class": _vm.getRowClass
                                    },
                                    on: { "click:row": _vm.rowClick },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "item.status",
                                        fn: function(ref) {
                                          var item = ref.item
                                          return [
                                            _c(
                                              "span",
                                              [
                                                _c(
                                                  "v-chip",
                                                  {
                                                    attrs: {
                                                      outlined: "",
                                                      "x-small": "",
                                                      color:
                                                        item.status ===
                                                        "SUCCESS"
                                                          ? "#2ABC4E"
                                                          : "#EA3F65"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.status ===
                                                          "SUCCESS"
                                                          ? _vm.$t("SUCCESS")
                                                          : _vm.$t("FAILED")
                                                      )
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "mt-2 mr-2",
                                      staticStyle: { position: "relative" }
                                    },
                                    [
                                      _c("div", { staticClass: "pageInfo" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.capturePageInfoText) +
                                            " "
                                        )
                                      ]),
                                      _c(
                                        "div",
                                        [
                                          _c("v-pagination", {
                                            staticClass: "capturePageAlign",
                                            attrs: {
                                              length: _vm.captureTotalPages,
                                              "total-visible": 5
                                            },
                                            on: {
                                              input: function($event) {
                                                return _vm.capturePaging($event)
                                              }
                                            },
                                            model: {
                                              value: _vm.capturePageIndex,
                                              callback: function($$v) {
                                                _vm.capturePageIndex = $$v
                                              },
                                              expression: "capturePageIndex"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "capture-image-section" },
                                [
                                  _vm.captureFailCode === null
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "image-preview-wrapper",
                                          staticStyle: { position: "relative" }
                                        },
                                        [
                                          _vm.selectedImage &&
                                          !_vm.imageLoadError
                                            ? _c("v-img", {
                                                staticClass:
                                                  "rounded preview-image",
                                                attrs: {
                                                  src: _vm.selectedImage,
                                                  contain: ""
                                                },
                                                on: {
                                                  error: _vm.handleImageError,
                                                  load: function($event) {
                                                    _vm.imageLoading = false
                                                  }
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "placeholder",
                                                      fn: function() {
                                                        return [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-flex align-center justify-center fill-height"
                                                            },
                                                            [
                                                              _c(
                                                                "v-progress-circular",
                                                                {
                                                                  attrs: {
                                                                    indeterminate:
                                                                      ""
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      },
                                                      proxy: true
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  3293038581
                                                )
                                              })
                                            : !_vm.imageLoading
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-center justify-center grey lighten-3 rounded no-image"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "No Image Available"
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.selectedImage &&
                                          !_vm.imageLoadError
                                            ? _c(
                                                "div",
                                                { staticClass: "fullscreen" },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass:
                                                        "fullscreen-btn",
                                                      attrs: {
                                                        small: "",
                                                        disabled: !_vm.selectedImage
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          ;(_vm.fullImageDialog = true),
                                                            (_vm.imageRotation = 0),
                                                            (_vm.imageZoom = 1)
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: { small: "" }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-fullscreen"
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    : _c(
                                        "v-card",
                                        { staticClass: "capture-fail-card" },
                                        [
                                          _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "capture-fail-title mb-4"
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      color: "#f5a623",
                                                      size: "42"
                                                    }
                                                  },
                                                  [_vm._v("mdi-alert")]
                                                ),
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CAPTURE ATTEMPT FAILED"
                                                    )
                                                  )
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "capture-fail-body"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "capture-fail-code-box"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "capture-fail-label"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "Error Code:"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "capture-fail-code-value"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.captureFailCodeText
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "capture-fail-reason-box"
                                                  },
                                                  [
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("Reason:")
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.captureFailReason
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "capture-fail-actions mt-4"
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass: "btn",
                                                    attrs: { text: "" },
                                                    on: {
                                                      click: _vm.retryCapture
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          left: "",
                                                          small: ""
                                                        }
                                                      },
                                                      [_vm._v("mdi-camera")]
                                                    ),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "Retry Capture"
                                                          )
                                                        ) +
                                                        " "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ])
                                        ]
                                      )
                                ],
                                1
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.activeTab === 0
                    ? _c(
                        "v-card-actions",
                        { staticClass: "details-actions" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn",
                              on: {
                                click: function($event) {
                                  return _vm.handleSaveBtnClick()
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("Save")) + " ")]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn",
                              attrs: { text: "" },
                              on: { click: _vm.closeDetails }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("Cancel")) + " ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.activeTab === 1
                    ? _c(
                        "v-card-actions",
                        { staticClass: "details-actions mt-6" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn",
                              attrs: { text: "" },
                              on: { click: _vm.closeDetails }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("Close")) + " ")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm.fullImageDialog
            ? _c(
                "v-dialog",
                {
                  attrs: {
                    persistent: "",
                    "retain-focus": false,
                    "max-width": "900",
                    transition: "dialog-bottom-transition"
                  },
                  model: {
                    value: _vm.fullImageDialog,
                    callback: function($$v) {
                      _vm.fullImageDialog = $$v
                    },
                    expression: "fullImageDialog"
                  }
                },
                [
                  _c(
                    "v-card",
                    { staticClass: "d-flex flex-column zoom-dialog-card" },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            height: "64px",
                            "background-color": "#001E38",
                            width: "100%",
                            display: "flex",
                            "align-items": "center",
                            padding: "0 16px"
                          }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                                dark: "",
                                small: "",
                                disabled: _vm.shelfStatusZoom <= 0.25,
                                title: _vm.$t("Zoom Out")
                              },
                              on: { click: _vm.zoomOut }
                            },
                            [
                              _c("v-icon", [
                                _vm._v("mdi-magnify-minus-outline")
                              ])
                            ],
                            1
                          ),
                          _c("span", { staticClass: "zoom-label" }, [
                            _vm._v(
                              _vm._s(Math.round(_vm.shelfStatusZoom * 100)) +
                                "%"
                            )
                          ]),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                                dark: "",
                                small: "",
                                disabled: _vm.shelfStatusZoom >= 5,
                                title: _vm.$t("Zoom In")
                              },
                              on: { click: _vm.zoomIn }
                            },
                            [
                              _c("v-icon", [_vm._v("mdi-magnify-plus-outline")])
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                                dark: "",
                                small: "",
                                title: _vm.$t("Reset Zoom")
                              },
                              on: { click: _vm.resetZoom }
                            },
                            [_c("v-icon", [_vm._v("mdi-magnify-close")])],
                            1
                          ),
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "", dark: "" },
                              on: { click: _vm.handleClose }
                            },
                            [_c("v-icon", [_vm._v("mdi-close")])],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          ref: "imageViewport",
                          staticClass: "image-viewport",
                          style: {
                            cursor: _vm.isDragging ? "grabbing" : "grab"
                          },
                          on: {
                            wheel: function($event) {
                              $event.preventDefault()
                              return _vm.onWheel($event)
                            },
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.onMouseDown($event)
                            },
                            mousemove: _vm.onMouseMove,
                            mouseup: _vm.onMouseUp,
                            mouseleave: _vm.onMouseUp
                          }
                        },
                        [
                          _vm.selectedImage
                            ? _c("img", {
                                staticClass: "zoomable-image",
                                class: { rotated: _vm.isRotated },
                                style: {
                                  transform:
                                    "rotate(" +
                                    _vm.imageRotation +
                                    "deg) translate(" +
                                    _vm.translateX +
                                    "px, " +
                                    _vm.translateY +
                                    "px) scale(" +
                                    _vm.shelfStatusZoom +
                                    ") ",
                                  transformOrigin: "0 0"
                                },
                                attrs: { src: _vm.selectedImage },
                                on: {
                                  load: _vm.onImageLoad,
                                  dragstart: function($event) {
                                    $event.preventDefault()
                                  }
                                }
                              })
                            : _c(
                                "div",
                                { staticClass: "no-image-placeholder" },
                                [_vm._v(_vm._s(_vm.$t("No Image Available")))]
                              )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "1100", scrollable: "", persistent: "" },
              model: {
                value: _vm.AssignDialog,
                callback: function($$v) {
                  _vm.AssignDialog = $$v
                },
                expression: "AssignDialog"
              }
            },
            [
              _c(
                "v-card",
                { staticClass: "popup" },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "d-flex justify-space-between" },
                    [
                      _c("h3", { staticClass: "d-flex align-center" }, [
                        _c("i", { staticClass: "ico ico-store mr-2" }),
                        _vm._v(_vm._s(_vm.$t("Camera Details")) + " ")
                      ])
                    ]
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-text",
                    {
                      staticStyle: {
                        "max-height": "70vh",
                        "overflow-y": "auto"
                      }
                    },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "8" } },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "pa-3",
                                  staticStyle: { "box-shadow": "none" }
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "tit-label",
                                      staticStyle: {
                                        "font-size": "14px",
                                        color: "#aaa"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("Camera Info")) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "form-input",
                                            attrs: {
                                              label: _vm.$t("Camera ID"),
                                              placeholder: _vm.$t("Camera ID"),
                                              outlined: "",
                                              dense: "",
                                              "hide-details": "",
                                              disabled: ""
                                            },
                                            model: {
                                              value: _vm.detailslabelCode,
                                              callback: function($$v) {
                                                _vm.detailslabelCode = $$v
                                              },
                                              expression: "detailslabelCode"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "form-input",
                                            attrs: {
                                              label: _vm.$t("Location"),
                                              placeholder: _vm.$t("Location"),
                                              outlined: "",
                                              dense: "",
                                              "hide-details": "",
                                              disabled: ""
                                            },
                                            model: {
                                              value: _vm.detailsLocation,
                                              callback: function($$v) {
                                                _vm.detailsLocation = $$v
                                              },
                                              expression: "detailsLocation"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c("v-col", { attrs: { cols: "4" } })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "form-input",
                                            attrs: {
                                              label: _vm.$t("Config"),
                                              placeholder: _vm.$t("Config"),
                                              outlined: "",
                                              dense: "",
                                              "hide-details": "",
                                              disabled: ""
                                            },
                                            model: {
                                              value: _vm.detailsConfig,
                                              callback: function($$v) {
                                                _vm.detailsConfig = $$v
                                              },
                                              expression: "detailsConfig"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "form-input",
                                            attrs: {
                                              label: _vm.$t("Schedule"),
                                              placeholder: _vm.$t("Schedule"),
                                              outlined: "",
                                              dense: "",
                                              "hide-details": "",
                                              disabled: ""
                                            },
                                            model: {
                                              value: _vm.detailsSchedule,
                                              callback: function($$v) {
                                                _vm.detailsSchedule = $$v
                                              },
                                              expression: "detailsSchedule"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "form-input",
                                            attrs: {
                                              label: _vm.$t("Repeat Schedule"),
                                              placeholder: _vm.$t(
                                                "Repeat Schedule"
                                              ),
                                              outlined: "",
                                              dense: "",
                                              "hide-details": "",
                                              disabled: ""
                                            },
                                            model: {
                                              value: _vm.detailsRepeatSchedule,
                                              callback: function($$v) {
                                                _vm.detailsRepeatSchedule = $$v
                                              },
                                              expression:
                                                "detailsRepeatSchedule"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-card",
                                {
                                  staticClass: "pa-3",
                                  staticStyle: { "box-shadow": "none" }
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "tit-label",
                                      staticStyle: {
                                        "font-size": "14px",
                                        color: "#aaa"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("WiFi Settings")) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "form-input",
                                            attrs: {
                                              label: _vm.$t("SSID"),
                                              placeholder: _vm.$t("SSID"),
                                              outlined: "",
                                              dense: "",
                                              "hide-details": "",
                                              clearable: ""
                                            },
                                            model: {
                                              value: _vm.detailsSsid,
                                              callback: function($$v) {
                                                _vm.detailsSsid = $$v
                                              },
                                              expression: "detailsSsid"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "form-input",
                                            attrs: {
                                              value: _vm.showPwd
                                                ? _vm.detailsPassword
                                                : "••••••••",
                                              "append-icon": _vm.showPwd
                                                ? "mdi-eye"
                                                : "mdi-eye-off",
                                              label: _vm.$t("Password"),
                                              outlined: "",
                                              dense: "",
                                              "hide-details": ""
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.detailsPassword = $event
                                              },
                                              "click:append": function($event) {
                                                _vm.showPwd = !_vm.showPwd
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-card",
                                {
                                  staticClass: "pa-3",
                                  staticStyle: { "box-shadow": "none" }
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "tit-label",
                                      staticStyle: {
                                        "font-size": "14px",
                                        color: "#aaa"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("Upload Settings")) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "form-input",
                                            attrs: {
                                              label: _vm.$t("Host URL"),
                                              placeholder: _vm.$t("Host URL"),
                                              outlined: "",
                                              dense: "",
                                              "hide-details": "",
                                              clearable: ""
                                            },
                                            model: {
                                              value: _vm.detailsHost,
                                              callback: function($$v) {
                                                _vm.detailsHost = $$v
                                              },
                                              expression: "detailsHost"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "form-input",
                                            attrs: {
                                              label: _vm.$t("Key"),
                                              placeholder: _vm.$t("Key"),
                                              outlined: "",
                                              dense: "",
                                              "hide-details": "",
                                              clearable: ""
                                            },
                                            model: {
                                              value: _vm.detailsKey,
                                              callback: function($$v) {
                                                _vm.detailsKey = $$v
                                              },
                                              expression: "detailsKey"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "form-input",
                                            attrs: {
                                              value: _vm.showSecret
                                                ? _vm.detailsSecret
                                                : "••••••••",
                                              "append-icon": _vm.showSecret
                                                ? "mdi-eye"
                                                : "mdi-eye-off",
                                              label: _vm.$t("Secret"),
                                              outlined: "",
                                              dense: "",
                                              "hide-details": ""
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.detailsSecret = $event
                                              },
                                              "click:append": function($event) {
                                                _vm.showSecret = !_vm.showSecret
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-card",
                                {
                                  staticClass: "pa-3",
                                  staticStyle: { "box-shadow": "none" }
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "tit-label",
                                      staticStyle: {
                                        "font-size": "14px",
                                        color: "#aaa"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("Webhook URL Settings")
                                          ) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c("v-text-field", {
                                    staticClass: "form-input mt-2",
                                    attrs: {
                                      label: _vm.$t("Webhook URL"),
                                      placeholder: _vm.$t("Webhook URL"),
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.detailsWebhook,
                                      callback: function($$v) {
                                        _vm.detailsWebhook = $$v
                                      },
                                      expression: "detailsWebhook"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "pa-3",
                                  staticStyle: { "box-shadow": "none" }
                                },
                                [
                                  _c("v-data-table", {
                                    staticClass: "tbl-type01 mt-13 products",
                                    attrs: {
                                      headers: _vm.scheduleHeaders,
                                      items: _vm.scheduleList,
                                      "hide-default-footer": true,
                                      "items-per-page": -1,
                                      "fixed-header": ""
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-actions",
                    { staticClass: "justify-center" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn",
                          on: {
                            click: function($event) {
                              return _vm.handleSaveBtnClick()
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("Save")) + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn",
                          attrs: { text: "" },
                          on: {
                            click: function($event) {
                              _vm.detailsDialog = false
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("Cancel")) + " ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }